!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["react", "prop-types"], e) : "object" == typeof exports ? exports.Gitcomment = e(require("react"), require("prop-types")) : t.Gitcomment = e(t.React, t.PropTypes);
}(this, function (t, e) {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 0);
  }([function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), function (t) {
      function r(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function o(t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }

      function i(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
      }

      var s = n(2),
          u = n.n(s),
          a = n(3),
          c = (n.n(a), n(4)),
          p = n(5),
          f = n(6),
          l = n(7),
          m = n(8),
          h = function () {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
          }
        }

        return function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      }(),
          d = "_-GC_-GH_TOKEN",
          b = Object(c.a)({
        fetch: t.fetch
      }),
          v = Object(p.a)({
        getJsonFrom: b
      }),
          y = Object(f.a)({
        getJsonFrom: b
      }),
          g = Object(l.a)({
        fetch: t.fetch
      }),
          k = Object(m.a)({
        postJsonTo: g
      }),
          O = function (e) {
        function n(e) {
          r(this, n);
          var i = o(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
          return i.postCommentToIssue = function (t) {
            k({
              repo: i.props.repo,
              issueNumber: i.props.issueNumber,
              token: i.state.token,
              comment: t
            }).catch(i.handleError.bind(i)).then(function () {
              return i.updateComments();
            });
          }, i.state = {
            loaded: !1,
            comments: [],
            user: {},
            token: i.props.token || t.localStorage && t.localStorage.getItem(d)
          }, i;
        }

        return i(n, s["Component"]), h(n, [{
          key: "componentDidMount",
          value: function value() {
            this.saveToken(this.props.token), this.updateComments();
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(t) {
            var e = t.token;
            this.saveToken(e);
          }
        }, {
          key: "componentDidUpdate",
          value: function value(t, e) {
            e.token !== this.state.token && this.updateComments();
          }
        }, {
          key: "saveToken",
          value: function value(e) {
            return e && e !== t.localStorage.getItem(d) && (t.localStorage.setItem(d, e) || !0) && this.setState({
              token: e
            });
          }
        }, {
          key: "handleError",
          value: function value(e) {
            return e instanceof TypeError || 401 !== JSON.parse(e.message).status ? this.props.error && this.props.error(e) : (t.localStorage.setItem(d, ""), this.setState({
              token: ""
            }), this.props.requireAuth && this.props.requireAuth(JSON.parse(e.message)));
          }
        }, {
          key: "updateComments",
          value: function value() {
            var t = this;
            v({
              repo: this.props.repo,
              issueNumber: this.props.issueNumber,
              token: this.state.token
            }).then(function (e) {
              var n = e.map(function (t) {
                return {
                  id: t.id,
                  body: t.body,
                  created: t.created_at,
                  updated: t.updated_at,
                  url: t.url,
                  author: {
                    login: t.user.login,
                    avatar: t.user.avatar_url,
                    url: t.user.html_url
                  }
                };
              });
              return t.setState({
                loaded: !0,
                comments: n
              });
            }).then(function () {
              return t.state.token ? y({
                token: t.state.token
              }) : null;
            }).then(function (e) {
              return e ? t.setState({
                user: {
                  login: e.login,
                  name: e.name,
                  avatar: e.avatar_url,
                  url: e.html_url
                }
              }) : null;
            }).catch(this.handleError.bind(this));
          }
        }, {
          key: "render",
          value: function value() {
            return u.a.createElement("div", null, this.props.render(this.state.loaded, this.state.comments, this.state.user, this.postCommentToIssue));
          }
        }]), n;
      }();

      O.defaultProps = {
        token: void 0,
        error: void 0,
        requireAuth: void 0
      }, e.default = O;
    }.call(e, n(1));
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (e, n) {
    e.exports = t;
  }, function (t, n) {
    t.exports = e;
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      var e = t.fetch;
      return function (t, n) {
        var r = {
          Accept: "application/vnd.github.v3.full+json"
        };
        return n && (r = Object.assign({}, r, {
          Authorization: "token " + n
        })), e(t, {
          method: "GET",
          headers: r
        }).then(function (t) {
          if (!t.ok) throw new Error(JSON.stringify({
            status: t.status,
            statusText: t.statusText,
            "X-RateLimit-Limit": t.headers.get("X-RateLimit-Limit"),
            "X-RateLimit-Remaining": t.headers.get("X-RateLimit-Remaining"),
            "X-RateLimit-Reset": t.headers.get("X-RateLimit-Reset")
          }));
          return t.json();
        });
      };
    };
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      var e = t.getJsonFrom;
      return function (t) {
        var n = t.repo,
            r = t.issueNumber,
            o = t.token;
        return e("https://api.github.com/repos/" + n + "/issues/" + r + "/comments", o);
      };
    };
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      var e = t.getJsonFrom;
      return function (t) {
        var n = t.token;
        return e("https://api.github.com/user", n);
      };
    };
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      var e = t.fetch;
      return function (t, n, r) {
        return e(t, {
          method: "POST",
          headers: {
            Accept: "application/vnd.github.v3.full+json",
            "Content-Type": "application/json",
            Authorization: "token " + n
          },
          body: r
        }).then(function (t) {
          if (!t.ok) throw new Error(JSON.stringify({
            status: t.status,
            statusText: t.statusText,
            "X-RateLimit-Limit": t.headers.get("X-RateLimit-Limit"),
            "X-RateLimit-Remaining": t.headers.get("X-RateLimit-Remaining"),
            "X-RateLimit-Reset": t.headers.get("X-RateLimit-Reset")
          }));
          return t;
        });
      };
    };
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      var e = t.postJsonTo;
      return function (t) {
        var n = t.repo,
            r = t.issueNumber,
            o = t.token,
            i = t.comment;
        return e("https://api.github.com/repos/" + n + "/issues/" + r + "/comments", o, JSON.stringify({
          body: i
        }));
      };
    };
  }]);
});